export const Experiment = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Experiment',
    },
  },
};
